import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=43513ec5&scoped=true"
import script from "./HorizontalList.vue?vue&type=script&lang=js"
export * from "./HorizontalList.vue?vue&type=script&lang=js"
import style0 from "./HorizontalList.vue?vue&type=style&index=0&id=43513ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_babel-core@7.0.0-bridge.0_@babel+core@7.24.4__css_qrpa3sa2ebgqrippt3vducq6r4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43513ec5",
  null
  
)

export default component.exports